import { AnnouncementAction } from '@/store/actions/announcement';
import { AuthActions } from '@/store/actions/auth';
import { BackOfficeActions } from '@/store/actions/backoffice';
import { BenefitActions } from '@/store/actions/benefit';
import { CalendarActions } from '@/store/actions/calendar';
import { companyActions } from '@/store/actions/company';
import { dashboardAction } from '@/store/actions/dashboard';
import { DepartmentActions } from '@/store/actions/departments';
import { DocumentAction } from '@/store/actions/document';
import { EmployeeActions } from '@/store/actions/employee';
import { firebaseActions } from '@/store/actions/firebase';
import { LeavesAction } from '@/store/actions/leaves';
import { LocationActions } from '@/store/actions/locations';
import { MarketplaceAction } from '@/store/actions/marketplace.js';
import { staticActions } from '@/store/actions/static';
import { tasksAction } from '@/store/actions/tasks';
import { TimelineActions } from '@/store/actions/timeline';
import { TimeOffAction } from '@/store/actions/timeoff';
import { WorkflowActions } from '@/store/actions/workflow';

export default {
  // firebase action
  getUserInfo: firebaseActions.getUserToken,
  logoutUser: firebaseActions.logoutCurrentUser,
  loginUser: firebaseActions.loginUser,
  sendAuthEmail: firebaseActions.sendSignInEmail,
  sendInvite: firebaseActions.sendInvite,
  sendResetEmail: firebaseActions.sendResetEmail,
  uploadImage: firebaseActions.uploadImage,
  uploadPrivateDocuments: firebaseActions.uploadPrivateDocuments,
  updateUserInfo: firebaseActions.updateUserInfo,
  fbResetPW: firebaseActions.resetPassword,
  // static endpoints
  countries: staticActions.countries,

  // protected endpoints
  dashboard: dashboardAction.dashboard,

  companyInfo: companyActions.companyInfo,
  company: companyActions.company,
  companyUpdate: companyActions.update,
  companyAddMembership: companyActions.saveMembership,
  companyTimeline: companyActions.timeline,
  companyUpdateLogo: companyActions.updateLogo,
  companyStartBillingSession: companyActions.startBillingSession,
  companyMembershipInfo: companyActions.membershipInfo,
  companyMembershipSessionCancelled: companyActions.membershipSessionCancelled,

  // Auth endpoints
  authActivate: AuthActions.activate,
  authStatus: AuthActions.status,
  authResetPassword: AuthActions.generatePasswordEmail,
  authUserByCode: AuthActions.userByActivationCode,
  authActivateEmp: AuthActions.activateEmpAccount,
  // calendar actions
  calendarInfo: CalendarActions.info,
  calendarSearch: CalendarActions.search,
  calendarSync: CalendarActions.sync,
  calendarUnSync: CalendarActions.unsync,
  calendarPreview: CalendarActions.preview,
  calendarUpdateEntry: CalendarActions.updateEntry,
  calendarDeleteEntry: CalendarActions.deleteEntry,
  calendarAddEntry: CalendarActions.addEntry,

  // locations
  locationFind: LocationActions.find,
  locationAdd: LocationActions.add,
  locationDelete: LocationActions.delete,
  locationEdit: LocationActions.edit,
  locationGet: LocationActions.get,

  // departments
  departmentFind: DepartmentActions.find,
  departmentGet: DepartmentActions.get,
  departmentDelete: DepartmentActions.delete,
  departmentEdit: DepartmentActions.edit,
  departmentAdd: DepartmentActions.add,

  // workflows
  workflowFind: WorkflowActions.find,
  workflowCreate: WorkflowActions.create,
  workflowDelete: WorkflowActions.delete,
  workflowEdit: WorkflowActions.edit,
  workflowGet: WorkflowActions.get,
  workFlowToDos: WorkflowActions.getWorkflowToDos,

  // backoffice
  backofficeFind: BackOfficeActions.find,
  backofficeAdd: BackOfficeActions.add,
  backofficeDelete: BackOfficeActions.delete,
  backofficeEdit: BackOfficeActions.edit,
  backofficeGet: BackOfficeActions.get,

  // leavetypes
  leaveTypesFind: LeavesAction.find,
  leaveTypesAdmin: LeavesAction.search,
  leaveTypesAdd: LeavesAction.add,
  leaveTypesDelete: LeavesAction.delete,
  leaveTypesEdit: LeavesAction.edit,
  leaveTypesGet: LeavesAction.get,

  // market place offers
  marketplaceOfferFind: MarketplaceAction.find,
  findBenefits: BenefitActions.find,
  getBenefit: BenefitActions.get,
  addBenefit: BenefitActions.add,
  editBenefit: BenefitActions.edit,
  deleteBenefit: BenefitActions.delete,
  productDetails: BenefitActions.productDetails,
  activateOffer: BenefitActions.activateOffer,
  upvoteOffer: BenefitActions.upvote,
  saveSearch: MarketplaceAction.saveSearch,
  getSearch: MarketplaceAction.getSearch,
  marketplaceInfo: MarketplaceAction.info,

  // provider endpoints
  providerInfo: BenefitActions.providerInfo,
  providerInfoByID: BenefitActions.providerInfoByID,
  addProviderInfo: BenefitActions.addProviderInfo,
  getProviderBenefits: BenefitActions.getProviderBenefits,
  addProviderBenefits: BenefitActions.addProviderBenefits,
  deleteProviderBenefits: BenefitActions.deleteProviderBenefits,
  editProviderBenefits: BenefitActions.editProviderBenefits,
  providerRecommendation: BenefitActions.providerRecommendation,
  addProviderRecommendation: BenefitActions.addProviderRecommendation,
  editProviderRecommendation: BenefitActions.editProviderRecommendation,
  getProviderRecommendation: BenefitActions.getProviderRecommendation,

  // timeoff
  findTimeOffs: TimeOffAction.find,
  deleteTimeOff: TimeOffAction.delete,
  editTimeOff: TimeOffAction.edit,
  infoTimeOff: TimeOffAction.info,
  addTimeOff: TimeOffAction.add,
  getTimeOffByIdAndAggregation: TimeOffAction.getByIdAndAggregation,
  getTimeOff: TimeOffAction.get,
  rollbackTimeoff: TimeOffAction.rollback,
  aggregateTimeoff: TimeOffAction.aggregate,

  // employee
  employeeAddress: EmployeeActions.Address,
  employeeGet: EmployeeActions.Get,
  employeeFind: EmployeeActions.Find,
  employeeMe: EmployeeActions.Me,
  employeeInfo: EmployeeActions.Info,
  employeeAddressSave: EmployeeActions.AddOrUpdateAddress,
  employeeSave: EmployeeActions.Save,
  employeeAdd: EmployeeActions.Add,
  employeeDelete: EmployeeActions.Delete,
  employeeTimeline: EmployeeActions.Timeline,
  employeeAddToTimeline: EmployeeActions.AddToTimeline,
  employeeOffBoarding: EmployeeActions.Offboarding,
  employeeProfile: EmployeeActions.Profile,
  employeeMePersonal: EmployeeActions.MePersonal,
  employeeMePersonalUpdate: EmployeeActions.UpdateMePersonal,
  employeePersonal: EmployeeActions.Personal,
  employeePersonalUpdate: EmployeeActions.UpdatePersonal,

  // document
  documentSave: DocumentAction.AddOrUpdate,
  documentGet: DocumentAction.Get,
  documentAll: DocumentAction.All,

  // announcements
  announcementFind: AnnouncementAction.Find,
  announcementDelete: AnnouncementAction.Delete,
  announcementEdit: AnnouncementAction.Edit,
  announcementGet: AnnouncementAction.Get,
  announcementAdd: AnnouncementAction.Add,

  // tasks
  tasksFind: tasksAction.Find,
  tasksComplete: tasksAction.Complete,

  // timeline
  timelineGet: TimelineActions.Get,
  timelinePut: TimelineActions.Put,
  timelineDelete: TimelineActions.Delete,

  // access requests
  accessRequestList: AuthActions.accessRequestList,
  addAccessRequest: AuthActions.addAccessRequest,
};